<template>
    <div class="page-footer" v-show="isShow">
        <div class="logo-wrap" style="display: none">
            <div class="left-logo">
                <img src="@/static/common/foot-logo.png" alt="" />
            </div>
        </div>

        <div class="web-footer" style="display: none">
            <div class="footer-left">
                <div class="left-info">
                    <div class="left-item">
                        <div class="left-label">
                            <router-link to="/about" class="group-title"> About Us </router-link>
                        </div>
                        <div class="left-text">
                            GreatWhip is a dynamic and high standard brand, we are committed to providing our customers with the best products and
                            services, 7/24 full service.
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-center">
                <div class="nav-group">
                    <div class="group-item">
                        <div class="group-title">
                            <router-link to="/contact" class="group-title"> Contact Us </router-link>
                        </div>

                        <div class="info-box">
                            <div class="info-item">
                                <img src="@/static/common/foot-tel.png" alt="" />
                                <span> {{ vuex_config.comPhone }}</span>
                            </div>
                            <div class="info-item">
                                <img src="@/static/common/foot-email.png" alt="" />
                                <span> {{ vuex_config.comAddress }}</span>
                            </div>
                            <div class="links">
                                <a href="">
                                    <img src="@/static/common/foot-link1.png" alt="" />
                                </a>
                                <a href="">
                                    <img src="@/static/common/foot-link2.png" alt="" />
                                </a>
                                <a href="">
                                    <img src="@/static/common/foot-link3.png" alt="" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="group-item">
                        <div class="group-title">
                            <router-link :to="vuex_product_cate_1.route" class="group-title">
                                <!-- Cream Charger -->
                                {{ vuex_product_cate_1.title }}
                            </router-link>
                        </div>
                        <div class="group-title">
                            <router-link :to="vuex_product_cate_2.route" class="group-title">
                                <!-- Cream Dispenser -->
                                {{ vuex_product_cate_2.title }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-right">
                <button class="btn-ripple fit-text btn-dingyue" @click="$router.push('/contact?apply=1')">Distributor</button>
            </div>
        </div>

        <div class="beian-box" style="display: none">
            <div class="beian-ctx">
                <div class="beian" v-html="vuex_config.comBeian"></div>
                <!-- <a href="https://beian.miit.gov.cn/" target="_blank">© Copyright 2024 COMPANY NAME. All Rights Reserved.</a> -->
                <!-- <a href="https://beian.miit.gov.cn/" target="_blank"> {{ vuex_config.comBeian }} </a> -->
                <!-- <span>{{ vuex_config.comBeian }}</span> -->
            </div>
        </div>

        <div class="myWrap commonMyWrap">
            <img src="../../static/foot/bottomLogo.png" class="bottomLogo" alt="" />
            <div class="flexBox" v-if="!vuex_h5">
                <div class="linkBtn" @click="goPage(0)">{{ $t('产品') }}</div>
                <div class="linkBtn" @click="goPage(5)" v-if="lang == 'zh'">{{ $t('私人定制') }}</div>
                <div class="linkBtn" @click="goPage(1)">{{ $t('签约艺术家') }}</div>
                <div class="linkBtn" @click="goPage(3)">{{ $t('新闻动态') }}</div>
                <div class="linkBtn" @click="goPage(2)">{{ $t('关于海伦') }}</div>
                <div class="linkBtn" @click="goPage(4)">{{ $t('联系我们') }}</div>
            </div>
            <div class="bottomCenterBox" v-if="false">
                <div class="customBtn btn-ripple" @click="goPage(5)">私人订制</div>
            </div>
            <!-- <div class="bottomFlexBox">
                <div class="bottomLogoFlexBox">
                    <div class="bottomLogo2 bg1" @click="bottomBtn(0)"></div>
                    <div class="bottomLogo2 bg2" @click="bottomBtn(1)"></div>
                    <div class="bottomLogo2 bg3" @click="bottomBtn(2)"></div>
                    <div class="bottomLogo2 bg4" @click="bottomBtn(3)"></div>
                    <div class="bottomLogo2 bg5" @click="bottomBtn(4)"></div>
                    <div class="bottomLogo2 bg6" @click="bottomBtn(5)"></div>
                </div>
            </div> -->
            <div class="bottomFlexBox mt20">
                <div class="bottomText" v-html="vuex_config.comBeian"></div>
            </div>
            <div class="bottomHeight"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'web-footer',
    components: {},
    props: [],
    data() {
        return {
            isShow: true,
        }
    },
    computed: {
        ...mapState(['vuex_product_cate_1', 'vuex_product_cate_2', 'vuex_config']),

        groupList() {
            let arr = [
                { title: '关于石磨坊', route: '/companyProfile' },
                { title: '加入⽯磨坊', route: '/job' },
                { title: '联系我们', route: '/contact' },
                { title: '帮助中心', route: '/help' },
                { title: '使用条款', route: '/terms' },
            ]

            return arr
        },
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(newV) {
                // 定制鼓页面，隐藏顶部导航
                if (newV == '/product-made') {
                    this.isShow = false
                } else {
                    this.isShow = true
                }
            },
        },
    },

    created() {},

    methods: {
        toNav(item) {
            this.$router.push(item.route)
        },
        goPage(type) {
            if (type == 0) {
                // 产品系列
                this.$router.push('/productListFirst')
            } else if (type == 1) {
                // 艺术家
                this.$router.push('/artistList')
            } else if (type == 2) {
                // 关于海伦
                this.$router.push('/about')
            } else if (type == 3) {
                // 新闻动态
                this.$router.push('/news')
            } else if (type == 4) {
                // 联系我们
                this.$router.push('/contact')
            } else if (type == 5) {
                // 联系我们
                this.$router.push('/product-made')
            }
        },
        bottomBtn(type) {
            if (type == 0) {
                // 微信
            } else if (type == 1) {
                // 视频号
            } else if (type == 2) {
                // 抖音
            } else if (type == 3) {
                //  小红书
            } else if (type == 4) {
                // 脸书
            } else if (type == 5) {
                // 推特
            }
        },
    },
}
</script>

<style>
a {
    color: #ffffff;
}
@media screen and (max-width: 1024px) {
    a {
        font-size: 14px;
        color: #ffffff;
    }
}
</style>

<style scoped lang="less">
.page-footer {
    width: 100%;
    padding-top: 67px;
    background: #000000;

    .myWrap {
        width: @width;
        overflow: hidden;
        margin: 0 auto;
    }

    .bottomLogo {
        width: 373px;
        height: 127px;
        display: block;
        margin: 0 auto 40px auto;
    }

    .flexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 72px;

        .linkBtn {
            font-size: 18px;
            line-height: 18px;
            color: #ffffff;
            margin-right: 115px;
            cursor: pointer;
        }

        .linkBtn:hover {
            text-decoration: underline;
            color: #ff4d00;
        }

        .linkBtn:last-child {
            margin-right: 0;
        }
    }

    .customBtn {
        width: 300px;
        height: 50px;
        background: #ff4d00;
        margin: 0 auto;
        font-size: 20px;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .bottomFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 110px;

        &.mt20 {
            margin-top: 30px;
        }

        .bottomLogoFlexBox {
            display: flex;
            align-items: center;
            justify-content: center;

            .bottomLogo2 {
                width: 29px;
                height: 29px;
                display: block;
                margin-right: 15px;
                cursor: pointer;

                .bottomLogoImg {
                    width: 100%;
                }
            }

            .bottomLogo2.bg1 {
                background: url(../../static/foot/wx.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg2 {
                background: url(../../static/foot/sph.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg3 {
                background: url(../../static/foot/dy.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg4 {
                background: url(../../static/foot/xhs.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg5 {
                background: url(../../static/foot/ls.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg6 {
                background: url(../../static/foot/tt.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg1:hover {
                background: url(../../static/foot/wx2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg2:hover {
                background: url(../../static/foot/sph2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg3:hover {
                background: url(../../static/foot/dy2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg4:hover {
                background: url(../../static/foot/xhs2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg5:hover {
                background: url(../../static/foot/ls2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2.bg6:hover {
                background: url(../../static/foot/tt2.png) no-repeat;
                background-size: 100% 100%;
            }

            .bottomLogo2:last-child {
                margin-right: 0;
            }
        }

        .bottomText {
            font-size: 14px;
            line-height: 14px;
            color: #999999;
        }
    }

    .bottomHeight {
        width: 100%;
        height: 50px;
    }
}

.logo-wrap {
    width: @width;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 43px;

    .left-logo {
        text-align: left;

        img {
            width: 141px;
            height: 82px;
        }
    }
}

.web-footer {
    width: @width;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 60px;

    .footer-left {
        width: 640px;
        padding-right: 180px;

        .left-info {
            .left-item {
                margin-bottom: 10px;

                .left-label {
                    a {
                        font-family: Poppins, Poppins;
                        font-weight: bold;
                        font-size: 22px;
                        color: #333333;
                    }
                }

                .left-text {
                    margin-top: 24px;
                    font-family: OPPOSans, OPPOSans;
                    font-weight: bold;
                    font-size: 14px;
                    color: #888888;
                    line-height: 24px;
                }
            }
        }
    }

    .footer-center {
        flex: 1;
        display: flex;
        justify-content: space-evenly;
        padding-right: 100px;

        .nav-group {
            flex: 1;

            display: flex;
            justify-content: space-between;

            .group-title {
                margin-bottom: 24px;
                cursor: pointer;
                font-family: Poppins, Poppins;
                font-weight: bold;
                font-size: 22px;
                color: #333333;

                a {
                    cursor: pointer;
                    font-family: Poppins, Poppins;
                    font-weight: bold;
                    font-size: 22px;
                    color: #333333;
                }
            }

            .info-box {
                .info-item {
                    margin-bottom: 18px;

                    img {
                        margin-right: 8px;
                        width: 20px;
                        height: 20px;
                    }

                    span {
                        font-family: OPPOSans, OPPOSans;
                        font-weight: bold;
                        font-size: 16px;
                        color: #888888;
                    }
                }

                .links {
                    margin-top: 40px;

                    img {
                        margin-right: 20px;
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }
    }

    .footer-right {
        .btn-dingyue {
            width: 150px;
            height: 40px;
            background: #4ca5e4;

            font-family: OPPOSans, OPPOSans;
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
        }
    }
}

.top-logo {
    img {
        width: 201px;
    }
}

.desc-box {
    margin-top: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 14px;
    color: #dae8e2;
}

.info-box {
    margin-top: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 14px;
    color: #dae8e2;
}

.nav-box {
    .flex-between();
    width: 1600px;
    margin: 60px auto;
    border-top: 1px solid #41b48a;
    border-bottom: 1px solid #41b48a;
    height: 48px;
    line-height: 48px;

    .nav-item {
        flex: 1;

        a {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 48px;
            color: #ffffff;
        }
    }
}

.qrcode-box {
    .flex-center();
    padding-bottom: 60px;

    .qrcode-item {
        &:last-child {
            margin-left: 40px;
        }

        img {
            width: 190px;
            height: 190px;
            border-radius: 6px;
        }

        .text {
            margin-top: 15px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 16px;
            color: #dae8e2;
        }
    }
}

.beian-box {
    border-top: 1px solid #ddd;
    background: #f9fafc;

    .beian-ctx {
        width: @width;
        margin: 0 auto;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        text-align: left;

        font-family: OPPOSans, OPPOSans;
        font-weight: bold;
        font-size: 14px;
        color: rgba(153, 153, 153, 0.6);

        a {
            font-family: OPPOSans, OPPOSans;
            font-weight: bold;
            font-size: 14px;
            color: rgba(153, 153, 153, 0.6);
        }

        /deep/ a,
        p,
        span,
        div {
            font-family: OPPOSans, OPPOSans;
            font-weight: bold;
            font-size: 14px;
            color: rgba(153, 153, 153, 0.6);
        }

        .beian {
            font-family: OPPOSans, OPPOSans;
            font-weight: bold;
            font-size: 14px;
            color: rgba(153, 153, 153, 0.6);
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/zujian/pageFooter.less"></style>
